export default __webpack_public_path__ + "static/media/5.9ef7df15.png";